import React, { useMemo } from 'react';
import styled from 'styled-components';
import PhoenixTheme from '@airasia/phoenix-components/components/Theme';
import RadioGroup from '@airasia/phoenix-components/components/RadioGroup';
import { string, array, element, bool } from 'prop-types';
import { SubBodyText } from '../Text';
import Wrapper from '../Wrapper';

const Title = styled(SubBodyText)`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.darkBlack};
`;
const RadioGroupWithTitle = ({
  title,
  iconPrefixTitle,
  displayTextProp,
  options,
  theme,
  move,
  ...restProps
}) => {
  const customOptions = useMemo(() => {
    return options.map(opt => ({
      value: opt.id,
      label: opt[displayTextProp],
    }));
  }, [options, displayTextProp]);
  return (
    <Wrapper>
      {title && (
        <Wrapper pb={3} display="flex" flexDirection="row">
          {iconPrefixTitle}
          <Title pl={10}>{title}</Title>
        </Wrapper>
      )}
      <PhoenixTheme theme={theme}>
        <RadioGroup {...restProps} options={customOptions} />
      </PhoenixTheme>
    </Wrapper>
  );
};

RadioGroupWithTitle.propTypes = {
  title: string,
  iconPrefixTitle: element,
  displayTextProp: string,
  options: array,
  theme: string,
  move: bool,
};

RadioGroupWithTitle.defaultProps = {
  displayTextProp: 'text',
  options: [],
  theme: 'AIRASIA_CLASSIC',
  move: false,
};

export default RadioGroupWithTitle;
